@if (control) {
<div class="mb-2 pb-2 position-relative divide">
  <label class="form-label">{{ label }}</label>
  <span *ngIf="isFieldRequired(control)" class="text-danger">*</span>
  <div class="position-relative divide-input">
    <input
    [type]="type"
    class="form-control"
    [formControl]="control"
    [placeholder]="placeholder || ''"
    (blur)="handleBlur($event)"
    (change)="onChange($event)"
    (focus)="applyFocusEvent ? formatInputValue($event) : ''"
    (keyup)="onKeyUp($event)"
    (input)="onInput($event)"
    id="{{ getControlName(control) }}"
    autocapitalize="off"
    [attr.min]="type === 'date' ? min : null"
    [attr.max]="type === 'date' ? max : null"
    [attr.maxlength]="maxLength"
    [attr.inputmode]="inputMode"
  />
  </div>
  @if (hint) {
    <small class="form-text text-muted d-block mt-1">{{ hint }}</small>
  }
  <div class="invalid-feedback d-block">
    <ng-container *ngIf="showErrors || control.touched">
      <div *ngFor="let error of control.errors | errorKeys : label">
        <div *ngIf="!control.hasError('pattern')">
          {{ error }}
        </div>
      </div>
      
      <div *ngIf="control.hasError('pattern') && (label.toLowerCase().includes('email') || type === 'email')">
        Please enter a valid email address
      </div>
      <div *ngIf="control.hasError('pattern') && !(label.toLowerCase().includes('email') || type === 'email')">
        {{ label.toLowerCase().includes('name') ? 'Enter only alpha characters' : ('Enter valid ' + label) }}
      </div>
      
      <div *ngIf="control.hasError('invalidDateFormat')">
        Please enter a valid date
      </div>
      
      <div *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
    </ng-container>
  </div>
</div>
}
